import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ALLOWANCE } from '../../constants/defaults';
import AllowanceChargeFieldRow from './AllowanceChargeFieldRow';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const AllowanceChargeSection = ({
  title,
  type,
  fields,
  onAdd,
  onEdit,
  onDelete,
  readOnly = false,
  isDocumentLevel = false,
}) => {
  const { eInvoiceForm } = useTranslatedMessages();
  const { line_item_form: lineItemForm } = eInvoiceForm;
  const sectionTexts = lineItemForm.allowance_charge_section;
  const isAllowance = type === ALLOWANCE;
  const buttonText = isAllowance ? sectionTexts.add_allowance_button : sectionTexts.add_charge_button;
  const emptyStateText = isAllowance ? sectionTexts.empty_allowances_text : sectionTexts.empty_charges_text;
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="subtitle1" color="text.secondary" fontWeight={500}>
          {title}
        </Typography>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={onAdd} disabled={readOnly}>
          {buttonText}
        </Button>
      </Stack>

      {fields.length > 0 ? (
        <Stack spacing={1}>
          {fields.map((item, index) => (
            <AllowanceChargeFieldRow
              key={item.id}
              item={item}
              index={index}
              type={type}
              isDocumentLevel={isDocumentLevel}
              onEdit={onEdit}
              onDelete={onDelete}
              readOnly={readOnly}
            />
          ))}
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          {emptyStateText}
        </Typography>
      )}
    </Box>
  );
};

export default AllowanceChargeSection;
